import { CookieService } from '@diamond/shared/utils';
import { useEffect, useState } from 'react';
import shallow from 'zustand/shallow';

import { useAuthStore, useShipToStore } from '../stores';

function useShipToHydrated() {
  const [hydrated, setHydrated] = useState(() =>
    typeof window === 'undefined'
      ? false
      : useShipToStore.persist.hasHydrated()
  );

  useEffect(() => {
    const finishHydration = () => setHydrated(true);
    const unsubscribe = useShipToStore.persist.onFinishHydration(finishHydration);
    if (useShipToStore.persist.hasHydrated()) {
      finishHydration();
    }
    return unsubscribe;
  }, []);

  return hydrated;
}

function getBuyerQueryToken(zustandToken: string | null | undefined) {
  if (typeof window === 'undefined') {
    return zustandToken ?? '';
  }
  return CookieService.getJwtToken() || zustandToken || '';
}

export function useBuyerHomeQueryGate() {
  const session = useAuthStore();
  const [selectedShipToId] = useShipToStore(
    (s) => [s.selectedShipToId],
    shallow
  );
  const hydrated = useShipToHydrated();
  const queryToken = getBuyerQueryToken(session.access_token);
  const canQuery = hydrated && !!selectedShipToId && !!queryToken;

  return { canQuery, queryToken, selectedShipToId, hydrated };
}
